export default function selector(storeState, props) {
    return {};
}
